module.exports = __webpack_public_path__ + "static/Grafik_family@2x.054c08c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/Hero/Grafik_family@2x.png
// module id = 425
// module chunks = 35783957827783